__turbopack_context__.v({
  "background": "VibrantOrbBackground-module-scss-module__NlP3Uq__background",
  "container": "VibrantOrbBackground-module-scss-module__NlP3Uq__container",
  "moveOrb": "VibrantOrbBackground-module-scss-module__NlP3Uq__moveOrb",
  "orb": "VibrantOrbBackground-module-scss-module__NlP3Uq__orb",
  "wrapper": "VibrantOrbBackground-module-scss-module__NlP3Uq__wrapper",
});
